import { format } from "@hejdoktor/resx-compiler"
export { format }
import { getLocale } from "@hejdoktor/resx-compiler"

import { R as _da } from "./PfaPhysiotherapyResources.da.resx"
import { R as _en } from "./PfaPhysiotherapyResources.en.resx"
import { R as _nb } from "./PfaPhysiotherapyResources.nb.resx"

type Translations = {
	"ApplyForOnlinePhysiotherapy": string,
	"ApplyForOnlinePhysiotherapyDescription": string,
	"ConsentDescription": string,
	"ConsentHeader": string,
	"ResultDescription": string,
	"ResultHeader": string,
	"WhoNeedsPhysiotherapy": string,
	"DeclarationOfConsent": string,
	"QuestionXOfY": string,
	"DidYouGetHurtAtWork": string,
	"AcceptAndApply": string,
	"AcceptAndSend": string,
	"PfaPhysiotherapyAcceptAndApplyInfo": string,
	"CprNumberShort": string,
	"MainInsured": string,
	"PfaPhysiotherapyClaimAcceptedTitle": string,
	"PfaPhysiotherapyClaimAcceptedText": string,
	"PfaPhysiotherapyClaimBadRequestTitle": string,
	"PfaPhysiotherapyClaimBadRequestText": string,
	"PfaPhysiotherapyClaimInternalServerErrorTitle": string,
	"PfaPhysiotherapyClaimInternalServerErrorText": string,
	"PfaPhysiotherapyClaimRejectedTitle": string,
	"PfaPhysiotherapyClaimRejectedText": string,
	"End": string,
	"Next": string,
}

const R = new Proxy({}, {
	get(target, name: keyof Translations, receiver) {
		if(process.env.enforcedLocale === "da" || (!process.env.enforcedLocale && getLocale("da") === "da")) {
			return _da[name] ?? name
		}

if(process.env.enforcedLocale === "en" || (!process.env.enforcedLocale && getLocale("da") === "en")) {
			return _en[name] ?? name
		}

if(process.env.enforcedLocale === "nb" || (!process.env.enforcedLocale && getLocale("da") === "nb")) {
			return _nb[name] ?? name
		}

		return name
	},
}) as Translations

export { R }